import type { PendingSocialAuth } from '@/core/models/auth';
import * as localStorageApi from '@/core/services/local-storage/local-storage';

export const PENDING_SOCIAL_AUTH_KEY = 'mindoasis:pendingSocialAuth';

export function setPendingSocialAuth(data: PendingSocialAuth | null): void {
  if (typeof window === 'undefined') return;

  if (data === null) {
    sessionStorage.removeItem(PENDING_SOCIAL_AUTH_KEY);
    return;
  }

  sessionStorage.setItem(PENDING_SOCIAL_AUTH_KEY, JSON.stringify(data));
}

export function getPendingSocialAuth(): PendingSocialAuth | null {
  if (typeof window === 'undefined') return null;

  try {
    const raw = sessionStorage.getItem(PENDING_SOCIAL_AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PendingSocialAuth;
  } catch {
    return null;
  }
}

export function markPendingSocialProfileCreated(): void {
  const pending = getPendingSocialAuth();
  if (!pending) return;

  setPendingSocialAuth({ ...pending, profileCreated: true });
}

export function clearPendingSocialAuth(): void {
  setPendingSocialAuth(null);
}

/** Clears pending social auth from both session and any legacy localStorage key. */
export function clearAllPendingSocialAuth(): void {
  clearPendingSocialAuth();
  localStorageApi.setItem(PENDING_SOCIAL_AUTH_KEY, null);
}
